<template>
  <v-layout align-start>
    <v-flex>
      <v-card class="overflow-hidden">
        <v-app-bar color="white" elevate-on-scroll flat>
          <v-row v-if="mostrarBusquedas">
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                outlined
                dense
                class="text-xs-center"
                v-model="searchAll"
                append-icon="search"
                label="Búsqueda"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" sm="6" md="6"> </v-col>
          </v-row>

          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="mostrarBusqueda"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark>
                  {{ mostrarBusquedas ? "search_off" : "search" }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{
              mostrarBusquedas
                ? "Ocultar filtros de búsqueda"
                : "Mostrar filtros de búsqueda"
            }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="mostrarInactivos"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark>
                  {{ inactivos ? "visibility_off" : "visibility" }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{
              inactivos ? "Ocultar Inactivos" : "Mostrar Inactivos"
            }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="exportarExcel"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> sim_card_download </v-icon>
              </v-btn>
            </template>
            <span>Exportar a Excel</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="mostrarCarga"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> file_upload </v-icon>
              </v-btn>
            </template>
            <span>Carga masiva de datos</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="agregar"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> add </v-icon>
              </v-btn>
            </template>
            <span>Ingresar nuevo registro</span>
          </v-tooltip>
        </v-app-bar>

        <v-sheet class="overflow-y-auto" :max-height="windowHeigth">
          <v-data-table
            dense
            fixed-header
            :height="windowHeigth - (isMobile ? 128 : 200)"
            :headers="isMobile ? headersMin : headers"
            :items="dtDocumentos"
            :hide-default-header="isMobile"
            mobile-breakpoint="0"
            sort-by="codigo"
            :search="searchAll"
            class="elevation-1"
            :loading="dtDocumentosLoad"
            loading-text="Cargando... Espere por favor"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': [-1, 100, 150, 200],
            }"
          >
            <template v-slot:[`item.opciones`]="{ item }">
              <v-btn x-small text dark color="primary" @click="editar(item)">
                <v-icon x-small>edit</v-icon>
              </v-btn>
            </template>

            <template v-slot:[`item.allData`]="{ item }" v-if="isMobile">
              <v-card>
                <v-list class="text-xs-left">
                  <v-btn
                    x-small
                    fab
                    dark
                    outlined
                    color="primary"
                    @click="editar(item)"
                  >
                    <v-icon x-small>edit</v-icon>
                  </v-btn>
                  <v-list-item>
                    <v-list-item-action>
                      <v-list-item-action-text>Código</v-list-item-action-text>

                      <v-list-item-action-text
                        >Descripción</v-list-item-action-text
                      >

                      <v-list-item-action-text
                        >Autorización</v-list-item-action-text
                      >
                      <v-list-item-action-text>Estado</v-list-item-action-text>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-subtitle class="text-left">{{
                        item.codigo
                      }}</v-list-item-subtitle>
                      <v-list-item-subtitle class="text-left">{{
                        item.siguiente_recibo
                      }}</v-list-item-subtitle>

                      <v-list-item-subtitle class="text-left">
                        <div
                          v-if="item.estado == 'I'"
                          @click="abrirDialogActivacion(item)"
                          class="error--text"
                        >
                          Inactivo
                        </div>
                        <div
                          v-else
                          @click="abrirDialogActivacion(item)"
                          class="success--text"
                        >
                          Activo
                        </div>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </template>

            <template v-slot:[`item.estado`]="{ item }">
              <div v-if="item.estado == 'I'">
                <v-btn
                  color="error"
                  x-small
                  text
                  dark
                  @click="abrirDialogActivacion(item)"
                >
                  <v-icon x-small>block</v-icon>
                </v-btn>
              </div>
              <div v-else>
                <v-btn
                  color="success"
                  x-small
                  text
                  dark
                  @click="abrirDialogActivacion(item)"
                >
                  <v-icon x-small>check</v-icon>
                </v-btn>
              </div>
            </template>

            <template v-slot:[`item.subarea`]="{ item }">
              <div v-if="item.subarea == 'NO DEFINIDO'" class="error--text">
                {{ item.subarea }}
              </div>
              <div v-else>
                {{ item.subarea }}
              </div>
            </template>

            <template v-slot:no-data>
              <div>No se encontraron registros</div>
            </template>
          </v-data-table>
        </v-sheet>
      </v-card>
      <v-dialog v-model="dialogCargaExcel" max-width="40%">
        <v-card>
          <v-app-bar color="white" elevate-on-scroll flat>
            <v-card-title>
              <span class="headline">Carga Masiva de Datos</span>
            </v-card-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="cerrarCarga"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Cancelar</span>
            </v-tooltip>
          </v-app-bar>

          <v-card-text>
            <v-file-input
              dense
              id="file"
              ref="file"
              v-model="file"
              @change="archivoCambiado"
              show-size
              chips
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              prepend-icon="attach_file"
              placeholder="Seleccione un archivo Excel"
            >
              <template v-slot:selection="{ text }">
                <v-chip color="primary">
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <v-spacer></v-spacer>
            <div v-show="mostrarErrores">
              <v-textarea
                outlined
                dense
                ref="error"
                v-model="error"
                :rules="[]"
                :readonly="true"
                :error-messages="errorMessages"
                label="Lista de Errores"
                placeholder="Lista de Errores"
                required
              ></v-textarea>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="guardarExcel"
                  color="success"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> done </v-icon>
                </v-btn>
              </template>
              <span>Cargar archivo</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogAlpha" persistent max-width="390">
        <v-card>
          <v-card-title>¿Está seguro?</v-card-title>
          <v-card-text
            >Esta acción {{ estado == "A" ? "desactivará" : "activará" }} el
            elemento seleccionado.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogAlpha = false">Cancelar</v-btn>
            <div v-if="estado == 'A'">
              <v-btn color="primary" text @click="desactivar()"
                >Continuar</v-btn
              >
            </div>
            <div v-else>
              <v-btn color="primary" text @click="activar()">Continuar</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogBeta"
        :fullscreen="isMobile"
        max-width="500px"
        persistent
      >
        <v-card ref="form">
          <v-app-bar color="white" elevate-on-scroll flat>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="guardar"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> save </v-icon>
                </v-btn>
              </template>
              <span>Guardar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="cerrar"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Cancelar</span>
            </v-tooltip>
          </v-app-bar>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    outlined
                    dense
                    ref="codigo"
                    v-model="codigo"
                    :readonly="!editarCodigo"
                    :rules="[$rules.requerido, $rules.max10]"
                    :error-messages="errorMessages"
                    @keydown.enter.prevent="guardar"
                    @keydown.escape.prevent="cerrar"
                    label="Código"
                    placeholder="Código"
                    required
                  ></v-text-field>

                  <v-text-field
                    outlined
                    dense
                    reverse
                    ref="siguiente_recibo"
                    v-model="siguiente_recibo"
                    @keydown.enter.prevent="guardar"
                    @keydown.escape.prevent="cerrar"
                    :rules="[$rules.requerido, $rules.numero]"
                    :error-messages="errorMessages"
                    label="Siguiente Correlativo"
                    
                    required
                  ></v-text-field>

                  
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import dialogMixin from "../plugins/dialogs.js";

export default {
  mixins: [dialogMixin],
  data() {
    return {
      //Declaración de variables globales
      usuario: this.$store.state.usuario.user,
      //Declaración de arrays
      dtDocumentos: [],
      dtDocumentosLoad: true,
      areaList: [],
      subareaList: [],
      areaPresupList: [],
      

      //Declaración de variables de Dialog
      dialogBeta: false,
      dialogCargaExcel: false,
      dialogAlpha: false,
      dialogGamma: false,

      //Declaración de variables de formulario
      id: "",
      codigo: "",
      siguiente_recibo: "",
      
      estado: "",

      file: null,

      load: false,
      icono: "",
      color: "",
      //Declaración de variables de tabla

      selected: [2],

      headers: [
        {
          text: "Opciones",
          value: "opciones",
          sortable: false,
          width: "1%",
          align: "center",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Código",
          value: "codigo",
          align: "left",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Siguiente Recibo",
          value: "siguiente_recibo",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        

        {
          text: "Activo",
          sortable: false,
          value: "estado",
          width: "1%",
          align: "center",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
      ],
      headersMin: [
        {
          text: "AllData",
          value: "allData",
          sortable: false,
          align: "center",
        },
      ],

      searchAll: "",
      esEditado: false,
      editarCodigo: false,

      editedIndexCco: false,
      inactivos: false,
      mostrarErrores: false,
      mostrarBusquedas: false,
      //variables de errrores
      valida: 0,
      errorMessages: "",

      error: "",
      //variables de tamaño de pantalla
      isMobile: false,

      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,

      windowWidth: window.innerWidth + this.auxWidth,
      windowHeigth: window.innerHeight,
    };
  },

  computed: {
    formTitle() {
      return !this.esEditado ? "Nuevo Registro" : "Actualizar Registro";
    },

    form() {
      return {
        codigo: this.codigo,
        siguiente_recibo: this.siguiente_recibo,
        
      };
    },
  },

  watch: {
    dialogBeta(val) {
      val || this.cerrar();
    },

    name() {
      this.errorMessages = "";
    },
  },
  mounted() {
    window.addEventListener("resize", this.getDimensions);
  },
  unmounted() {
    window.removeEventListener("resize", this.getDimensions);
  },

  created() {
    //this.$gtag.pageview('/areaDelPresupuestoPrueba')
    this.$store.dispatch("actualizarTitulo", "Talonarios");
    this.listar();
  },
  beforeDestroy() {
    this.$store.dispatch("actualizarTitulo", "");
  },

  methods: {
    archivoCambiado(e) {
      this.selectedFile = e;
    },
    cargarArchivo() {
      let me = this;

      const formData = new FormData();
      formData.append("id", this.id);
      formData.append("codigo", this.codigo);
      formData.append("siguiente_recibo", this.siguiente_recibo);
      

      formData.append("usuario", this.usuario);

      if (this.selectedFile != null) {
        formData.append("subido", this.selectedFile);
      } else {
        formData.append(null, null);
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo.",
          color: "error",
        });
        return;
      }


      axios
        .put("api/talonarios/cargarArchivo", formData)
        .then(function (response) {
          me.nombreArchivo = me.selectedFile.name;
          me.file = null;
          me.selectedFile = null;
          me.listar();
          me.dialogGamma = false;
          me.$store.dispatch("setSnackbar", {
            text: " Adjunto subido exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },

    getDimensions() {
      this.width = document.documentElement.clientWidth;
      this.height = document.documentElement.clientHeight;
      this.isMobile = this.width < 768;
    },
    listar() {
      let me = this;
      me.dtDocumentosLoad = true;
      axios
        .get("api/talonarios/listar")
        .then(function (response) {
          me.dtDocumentos = response.data;
          me.windowWidth = window.innerWidth + me.auxWidth;
          me.windowHeigth = window.innerHeight;
          me.dtDocumentosLoad = false;
        })
        .catch(function (error) {
          me.dtDocumentosLoad = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    mostrarInactivos() {
      this.inactivos = !this.inactivos;
      this.listar();
    },

    abrirDialogActivacion(item) {
      this.id = item.id;
      this.dialogAlpha = true;
      this.estado = item.estado;
    },

    mostrarBusqueda() {
      this.mostrarBusquedas = !this.mostrarBusquedas;
      this.windowWidth = window.innerWidth;
      this.windowHeigth = window.innerHeight;
    },

    archivoCambiado(e) {
      this.selectedFile = e;
    },

    cerrarCarga() {
      this.dialogCargaExcel = false;
      this.limpiarCargaExcel();
    },

    mostrarCarga() {
      this.dialogCargaExcel = true;
    },

    editar(item) {
      this.id = item.id;
      this.codigo = item.codigo;
      this.siguiente_recibo = item.siguiente_recibo;
      
      this.esEditado = true;
      this.editarCodigo = false;
      this.dialogBeta = true;

      //debe agregarse $nextTick para los elementos no renderizados hastas su llamada
    },
    agregar() {
      this.editarCodigo = true;
      this.dialogBeta = true;
    },

    cerrar() {
      this.dialogBeta = false;
      this.limpiar();
    },

    limpiar() {
      this.id = "";
      this.codigo = "";
      this.siguiente_recibo = "";
      
      this.dialogBeta = false;
      this.esEditado = false;
    },
    limpiarCargaExcel() {
      this.file = null;
      this.selectedFile = null;
      this.error = "";
      this.mostrarErrores = false;
    },

    guardar() {
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      if (this.esEditado) {
        //codigo para editar
        let me = this;
        axios
          .put("api/talonarios/actualizar", {
            id: me.id,
            codigo: me.codigo,
            siguiente_recibo: me.siguiente_recibo,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.cerrar();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro modificado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      } else {
        //codigo para guardar
        let me = this;
        axios
          .post("api/talonarios/crear", {
            codigo: me.codigo,
            siguiente_recibo: me.siguiente_recibo,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.esEditado = true;
            me.id = response.data;
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    exportarExcel() {
      let me = this;
      axios
        .get("api/talonarios/exportarExcel")
        .then(function (response) {
          me.downloadExcel(response.data);
        })
        .catch(function (error) {
          console.error(error);
        })
        .then(function () {
          me.listar();
        });
    },

    guardarExcel() {
      let me = this;
      const formData = new FormData();

      if (this.selectedFile != null) {
        formData.append(this.selectedFile.name, this.selectedFile);
        axios
          .put("api/talonarios/cargarExcel/" + me.usuario, formData)
          .then(function (response) {
            me.$store.dispatch("setSnackbar", {
              text: response.data,
              color: "success",
            });
            me.cerrarCarga();
            me.listar();
          })
          .catch(function (err) {
            me.mostrarErrores = true;
            me.$store.dispatch("setSnackbar", {
              text: "No se pudo cargar el archivo  seleccionado, verifique los errores e intente nuevamente.",
              color: "error",
            });
            me.error = err.response.data;
          });
      } else {
        formData.append(null, null);
        me.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo para cargar.",
          color: "warning",
        });
      }
    },

    validar() {
      this.valida = 0;

      Object.keys(this.form).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },

    activar() {
      let me = this;
      axios
        .put("api/talonarios/activar/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.listar();
          me.dialogAlpha = false;
          me.$store.dispatch("setSnackbar", {
            text: " Registro activado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    desactivar() {
      let me = this;
      axios
        .put("api/talonarios/desactivar/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.listar();
          me.dialogAlpha = false;
          me.$store.dispatch("setSnackbar", {
            text: "Registro desactivado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    download(link, title) {
      var element = document.createElement("a");
      element.setAttribute("href", link);
      element.setAttribute("download", title);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },

    //format datetime to dd/mm/yyyy hh:mm:ss
    
  },
};
</script>
